/* eslint-disable */
export default class EventoOre {
    c_project_id = null;
    oreInterne = 0;
    oreEsterneMontaggio = 0;
    oreEsterneAssistenza = 0;
    oreViaggio = 0;
    pernotto = false;
    tipoPernotto = 'I';
    fogliodilavoro = null;
    fct_timesheetwh_id = null;

    desc = ''

    constructor(c_project_id, oreInterne, oreEsterneMontaggio,
        oreEsterneAssistenza, oreViaggio, pernotto, tipoPernotto,
        fogliodilavoro, fct_timesheetwh_id) {
        //console.log("constructor")
        this.c_project_id = c_project_id;
        this.oreInterne = oreInterne;
        this.oreEsterneMontaggio = oreEsterneMontaggio;
        this.oreEsterneAssistenza = oreEsterneAssistenza;
        this.oreViaggio = oreViaggio;
        this.pernotto = pernotto;
        this.tipoPernotto = tipoPernotto;
        this.fogliodilavoro = fogliodilavoro;
        this.fct_timesheetwh_id = fct_timesheetwh_id
    }

    defaultValueZero(ore) {
        if (ore == "" || ore == null) {
            return 0;
        } else {
            return ore;
        }
    }

    daTestoATotMinuti(ore) {
        //parseFloat(this.defaultValueZero(this.oreInterne))
        var oreMinuti = parseFloat(this.defaultValueZero(ore))
        var minuti = Math.floor(oreMinuti) * 60
        //console.log(ore + "minuti1*" + minuti)
        minuti = parseFloat(minuti) + parseFloat(oreMinuti % 1) * 100
        //console.log(ore + "minuti2*" + minuti)
        return minuti
    }

    daMinutiAOre(minutiT) {
        if (minutiT > 0) {
            var ore = Math.floor(minutiT / 60)
            //console.log(minutiT + "ore" + ore)
            var minuti = (minutiT - (ore * 60)) / 100
            //console.log(minutiT + "minuti" + minuti)
            return ore + minuti
        } else {
            return 0
        }
    }

    totaleMinuti() {
        var totMinuti = this.daTestoATotMinuti(this.oreInterne) +
            this.daTestoATotMinuti(this.oreEsterneMontaggio) +
            this.daTestoATotMinuti(this.oreEsterneAssistenza) +
            this.daTestoATotMinuti(this.oreViaggio);

        return totMinuti
    }

    totaleOre() {
        var totOre = this.daMinutiAOre(this.totaleMinuti())

        //fare totale minuti e poi dividere

        return totOre.toFixed(2)
        //return 55
    }

    rappStr() {
        return '' + this.totaleOre() + (this.pernotto === 'Y' ? " P" : "") + this.desc
        //return '234' // this.totaleOre() + (this.pernotto == 'Y' ? " P" : "")
    }

}